import React from "react";

import LevelTestMonitor from "./LevelTestMonitor";
import { CONTAINER_MAX_WIDTH } from "../../../styles/layout";

// 관리자 > 레벨테스트 현황. 전체 응시 현황과 응시코드, 재원생 명단을 본다.
// 예전에는 '학원별 출제 내역' 화면 맨 아래에 붙어 있어서 스크롤을 한참 내려야
// 보였다(2026-09-15 지적). 출제 내역과 섞일 이유가 없어서 메뉴를 갈랐다.
const AdminLevelTestPage = () => {
  const isMobileW = Math.min(window.innerWidth, window.screen.width) <= 768;

  return (
    <div
      style={{
        padding: isMobileW ? "10px 14px 32px" : "26px 22px 44px",
        maxWidth: `${CONTAINER_MAX_WIDTH}px`,
        margin: "0 auto",
      }}
    >
      <LevelTestMonitor />
    </div>
  );
};

export default AdminLevelTestPage;
